<template>
  <div :class="[lang === 'ar' ? 'right-dir' : 'left-dir', 'wrapper']">
    <Insure @refresh="$emit('refresh')" @close="close" :id="data.id" method="post" :type="type" v-if="change && type !== 'features'" :checked="checked" />
    <div class="header">
      <div class="flexing">
        <div :class="[lang === 'ar' ? 'bold-ar': 'bold-en', 'titles']">{{ data.title }}</div>
        <label class="switch" v-if="showSwitch">
          <input @click="activation" v-model="checked" type="checkbox">
          <span :style="{borderColor: checked ? '#FFCB05' : '', boxShadow: checked ? ' 0px 0px 5px rgb(205,203,5)' : ' 0px 0px 5px rgb(106,106,106)'}" class="slider"></span>
          <div :style="{transform : checked ? 'translateX(1.2em)' : 'translateX(0em)'}" id="border" class="slider-border"></div>
        </label>
      </div>
      <div class="mini-title">
        <span :class="lang === 'ar' ? 'bold-ar' : 'bold-en'">
          <span v-if="data.price === 0">{{$t('free')}}</span>
          <span v-else>{{ data.price }} {{ $t('Bundles.sp')}}</span>
        </span>
        <span v-if="type !== 'features' && data.price !== 0" :class="lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">
          <span>/</span>
          <span> {{ data.type === 0 ?  $t('Bundles.day') : data.type === 1 ?  $t('Bundles.week') :  $t('Bundles.month') }}</span>
        </span>
      </div>
    </div>
    <div :class="[lang === 'ar' ? 'regular-ar' : 'regular-en', 'description']">
      {{data.description}}
      <div class="hotline-note" v-if="type === 'features' && data.type === 2 && !data.active">
        {{$t('feature.hotLineNote')}}
      </div>
    </div>
    <div v-if="type === 'features'">
      <span class="show" v-if="data.type !== 2" @click="showServiceData">
        {{$t('feature.show')}}
      </span>
      <span v-else-if="data.type === 2">
        <span class="show green-btn" v-if="data.active" @click="$store.state.activateHotLine = true">
          {{$t('feature.activateNum')}}
        </span>
        <span class="show red-btn" v-else-if="!data.active" @click="$store.state.deactivateHotLine = true">
          {{$t('feature.deactivateNum')}}
        </span>
      </span>
    </div>
  </div>
</template>
<script>
import Insure from '../../components/dialogs/Insure'
export default {
  props: {
    data: Object,
    type: String
  },
  components: { Insure },
  data () {
    return {
      lang: this.$lang,
      change: false,
      checked: true,
      showSwitch: false
    }
  },
  watch: {
  },
  created () {
    // Hide switch for hotline
    this.showSwitch = this.data.type !== 2
    if (this.type !== 'services') {
      this.checked = this.data.isActive === 1
    }
  },
  methods: {
    close () {
      this.checked = !this.checked
      this.change = false
    },
    activation () {
      this.change = true
      if (this.type === 'features') {
        this.showServiceData()
      }
    },
    showServiceData () {
      this.$router.push(this.data.type === 0 ? '/super-clip' : '/call-forward')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";
.hotline-note {
  color: #1D1D1D; font-style: italic; font-size: 13px;
}
.show {
  cursor: pointer;
  color: rgba(29, 29, 29, 0.70); font-weight: bold; font-size: 13px;
  text-decoration: underline;
}
.green-btn {
  color: #00DC5F !important;
}
.red-btn {
  color: #FF4E3E !important;
}
.switch {
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 2.8em;
  height: 1.5em;
  border-radius: 50px;
  box-shadow: 10px 10px 20px rgba(0,0,0,0.08);
  background: #F2F2F2;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  border: 1px solid rgb(106,106,106);
  border-radius: 50px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  //filter: blur(1px);
}

.slider:before {
  position: absolute;
  content: "";
  height: 1em;
  width: 1em;
  left: 0.2em;
  bottom: 0.18em;
  background: rgb(106,106,106);
  border-radius: inherit;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
}
.slider-border {
  height: .95em;
  width: .95em;
  border: .8px solid #ffffff;
  border-radius: 50%;
  position: absolute;
  left: 0.295em;
  bottom: 0.25em;
  filter: blur(1px);
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
  cursor: pointer;
}

.switch input:checked + .slider:before {
  transform: translateX(1.2em);
  background-color: $--yellow;
}
/*---------------------------------*/
.wrapper {
  padding: 0 3rem;
}
.flexing {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titles {
  color: $--yellow;
  font-size: 20px
}
.mini-title > span:first-child {
  font-size: 16px
}
.mini-title > span:last-child {
  font-size: 15px
}
.description {
  width: 100%;
  font-size: 14px;
  padding: 0.5rem  0;
}
/*----------------- responsive -------------------------*/
@media (max-width: 800px) {
  .wrapper {
    padding: 0 1.5rem
  }
}
/*-------------------------------------------------------*/
</style>
